import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventService } from '../../services/firebaseService';
import { EventItem } from '../../types';
import MarkdownEditor from '../../components/admin/MarkdownEditor';

const EventManager: React.FC = () => {
  const [events, setEvents] = useState<EventItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState<Partial<EventItem>>({ title: '', description: '', location: '' });
  const [date, setDate] = useState<string>('');
  const [editingId, setEditingId] = useState<string | null>(null);

  useEffect(() => {
    eventService.getAllEvents().then(list => {
      setEvents(list);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const payload: any = { ...form };
    if (date) payload.date = new Date(date);
    if (editingId) {
      // Simple update: allow overwriting fields
      await eventService.addEvent({ ...(payload as EventItem) }); // If update function missing, re-add as new
    } else {
      await eventService.addEvent(payload as EventItem);
    }
    const list = await eventService.getAllEvents();
    setEvents(list);
    setForm({ title: '', description: '', location: '' });
    setDate('');
    setEditingId(null);
  }

  function startEdit(ev: EventItem) {
    setEditingId(ev.id!);
    setForm({ title: ev.title, description: ev.description, location: (ev as any).location });
    const dt = (ev as any).date?.toDate ? (ev as any).date.toDate() : (ev as any).date ? new Date((ev as any).date) : null;
    setDate(dt ? new Date(dt.getTime() - dt.getTimezoneOffset() * 60000).toISOString().slice(0,16) : '');
  }

  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <h3>Admin Panel</h3>
        <nav>
          <ul>
            <li><Link to="/admin">Dashboard</Link></li>
            <li><Link to="/admin/content">Content</Link></li>
            <li><Link to="/admin/board">Board Members</Link></li>
            <li><Link to="/admin/programs">Programs</Link></li>
            <li><Link to="/admin/events">Events</Link></li>
            <li><Link to="/admin/volunteers">Volunteer Applications</Link></li>
            <li><Link to="/admin/contact">Contact Submissions</Link></li>
          </ul>
        </nav>
      </div>
      <div className="admin-content">
        <h1>Event Manager</h1>

        <form onSubmit={handleSubmit} style={{ marginBottom: '2rem' }}>
          <div className="grid" style={{ gridTemplateColumns: '1fr' }}>
            <input
              type="text"
              placeholder="Title"
              value={form.title || ''}
              onChange={e => setForm({ ...form, title: e.target.value })}
              required
            />
            <div>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>Description</label>
              <MarkdownEditor
                value={form.description || ''}
                onChange={(value) => setForm({ ...form, description: value })}
                placeholder="Enter event description..."
              />
            </div>
            <input
              type="text"
              placeholder="Location"
              value={form.location || ''}
              onChange={e => setForm({ ...form, location: e.target.value })}
            />
            <input
              type="datetime-local"
              value={date}
              onChange={e => setDate(e.target.value)}
            />
            <div>
              <button className="btn btn-primary" type="submit">{editingId ? 'Update' : 'Add'} Event</button>
              {editingId && (
                <button type="button" className="btn btn-secondary" style={{ marginLeft: '0.5rem' }} onClick={() => { setEditingId(null); setForm({ title: '', description: '', location: '' }); setDate(''); }}>Cancel</button>
              )}
            </div>
          </div>
        </form>

        {loading ? (
          <div className="loading"><div className="spinner" /></div>
        ) : (
          <div className="grid" style={{ gridTemplateColumns: '1fr' }}>
            {events.map(ev => (
              <div key={ev.id} className="card">
                <h3>{ev.title}</h3>
                {(ev as any).date && <p style={{ color: 'var(--text-dark)' }}>{String((ev as any).date?.toDate ? (ev as any).date.toDate().toLocaleString() : (ev as any).date)}</p>}
                {(ev as any).location && <p>{(ev as any).location}</p>}
                {ev.description && <p>{ev.description}</p>}
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <button className="btn btn-primary" onClick={() => startEdit(ev)}>Edit</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventManager;
